<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 40 40" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M18.5 22.8v3.9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-3.9c0-.8-.7-1.5-1.5-1.5s-1.5.6-1.5 1.5z" />
        <path d="M36.5 27.3c-2.7-2.7-6-4.8-9.7-5.9-.8-.2-1.6.2-1.9 1 .1.2 0 .4.1.6v6.5c0 .6-.5 1.1-1.1 1.1h-7.7c-.6 0-1.1-.5-1.1-1.1v-7.2s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1l-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1-.1-.2-.1h-.1c-.1 0-.1 0-.2-.1h-1c-3.6 1.1-7 3.2-9.7 5.9-1.1 1.1-1.7 2.5-1.9 4V35c0 2.6 2.1 4.7 4.7 4.7h27.5c2.6 0 4.7-2.1 4.7-4.7v-2.8c.3-1.9-.4-3.6-1.7-4.9zM6.2 36.8c-1 0-1.7-.8-1.7-1.7v-2.9c0-1 .4-2 1.1-2.7 1.8-1.9 4.1-3.4 6.5-4.4v4.4c0 2.2 1.8 4.1 4.1 4.1h7.7c2.2 0 4.1-1.8 4.1-4.1V25c2.4 1 4.6 2.5 6.5 4.4.7.7 1.1 1.7 1.1 2.7V35c0 1-.8 1.7-1.7 1.7l-27.7.1zm14-16.6c5.5 0 10-4.5 10-10V.2h-10c-5.5 0-10 4.5-10 10s4.5 10 10 10zm0-17h7v7c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
